import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { urlsPrivate } from 'src/environments/url-services';
import { SharedService } from '../shared/services/shared.services';

@Injectable({
  providedIn: 'root'
})
export class LevelconsultService extends SharedService {
  url: string = environment.server_api_url;

  constructor(http: HttpClient) {
    super(http);
  }

  requestData: any;
  
  subject = new Subject<any>();
  data = this.subject.asObservable();

  setdata = (data: any) => (this.requestData = data);
  getdata = () => this.requestData;
  deletedata = () => (this.requestData = undefined);

  getRequests(keyword: string) {
    return this.http.get(`${this.url}${urlsPrivate['get_solicitudes']}?keyword=${keyword}`).toPromise();
  }

  getUsers(keyword: string) {
    return this.http.get(`${this.url}${urlsPrivate['get_solicitantesfinderTopFive']}?keyword=${keyword}`).toPromise();
  }

  getServices(keyword: string) {
    return this.http.get(`${this.url}${urlsPrivate['get_servicios']}?keyword=${keyword}`).toPromise();
  }

  searchRequests(body: any) {
    let url = `${this.url}${urlsPrivate['search_solicitudes']}`;
    const keys = Object.keys(body);
    for (const [index, i] of keys.entries()) {
      url += `${index == 0 ? '?' : '&'}${i}=${body[i]}`;
    }
    return this.http.get(`${url}`).toPromise();
  }

  updateCatalog(body: any, userId: string) {
    return this.http.put(`${this.url}${urlsPrivate['catalogs_elements']}?usuarioId=${userId}`, body).toPromise();
  }

  descargarEsquema(item: any, id: number, idTwo: number, nameService: string, type:string): Observable<any> {
    return this.http.post<any>(`${this.url}${urlsPrivate[nameService]}${id}/${idTwo}/${type}`, item);
 }
}
